import { cva } from 'class-variance-authority'

export const cardStyle = cva(
  `
    flex
    items-center
    px-6
    py-4
    w-[388px]
    border
  `,
  {
    variants: {
      variant: {
        default: 'bg-neutral-0 text-neutral-900',
        success: 'text-success bg-green-0 border-green-50',
        danger: 'text-danger bg-red-0 border-red-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const bodyLeftStyle = cva(
  `
    pr-2
  `
)
